import { createFileRoute } from "@tanstack/react-router";
import { AdoptionQueuePage } from "@charphq/ui/components/layout/pages/AdoptionQueuePage";

export const Route = createFileRoute("/deployments_/adoption")({
  component: AdoptionQueuePage,
});
